import { getPrinterRulesId } from './chunk-GHIPCFZD.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

var getGenericError = ({
  key,
  message,
  id,
  section
}) => ({
  [key]: {
    id: "genericError" /* GENERIC_ERROR */,
    data: {
      message
    },
    kind: {
      id,
      data: {
        message
      },
      type: "genericError" /* GENERIC_ERROR */,
      section
    }
  }
});
var getPrinterRulesError = (key, field) => {
  const objectKey = getPrinterRulesId(key, field);
  return getGenericError({
    key: objectKey,
    id: field,
    message: i18n_config_default.t(
      `settingsModule.printerRulesSettings.printerRulesTable.errors.${field}`
    ),
    section: "printerRules" /* PRINTER_RULES */
  });
};
var printerRulesSchema = yup.lazy(
  (obj) => yup.object(
    mapValues(
      obj,
      (_, key) => yup.object().shape({
        name: yup.string().trim().required(JSON.stringify(getPrinterRulesError(key, "name"))),
        fromPrepStationId: yup.number().nullable().positive(getPrinterRulesError(key, "fromPrepStationId")).when("toPrepStationId", {
          is: -1,
          then: (schema) => schema,
          otherwise: (schema) => schema.notOneOf(
            [yup.ref("toPrepStationId")],
            getPrinterRulesError(key, "equalPrepStations")
          )
        }),
        toPrepStationId: yup.number().positive(getPrinterRulesError(key, "toPrepStationId")),
        startTime: yup.date(),
        endTime: yup.date().when("startTime", (startTime, schema) => {
          const time = startTime[0].toISOString().split("T")[1].slice(0, 5);
          const currStartTime = new Date(startTime[0]);
          if (time !== "23:45") {
            currStartTime.setMinutes(currStartTime.getMinutes() + 15);
          } else {
            currStartTime.setMinutes(currStartTime.getMinutes() + 1);
          }
          return currStartTime && schema.min(currStartTime, getPrinterRulesError(key, "timeOverlap"));
        })
      })
    )
  )
);

export { printerRulesSchema };
